import { format } from "date-fns";
import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "../../../../components";
import { SessionService } from "../../../../services";
import {
  formatCnpj,
  formatCpf,
  formatPrice
} from "../../../../utils";

const ReciboPrintLayout = ({ data }) => {
  const [empresa, setEmpresa] = useState(null);
  const sessionService = new SessionService();

  const totalPagamentos = (listaPagamentos) => {
    return listaPagamentos.reduce((acc, curr) => acc + curr.valorPago, 0);
  };

  useEffect(() => {
    const data = sessionService.getEmpresa();
    setEmpresa(data);
  }, []);

  function retornarCnpjCpf(dadosCliente) {
    if (dadosCliente?.cnpjCpf) {
      return dadosCliente?.naturezaSocial == "fisica"
        ? `, identificado pelo CPF ${formatCpf(dadosCliente.cnpjCpf)}`
        : `, identificado pelo CNPJ ${formatCnpj(dadosCliente.cnpjCpf)}`;
    }
  }

  return data?.pagamentos?.length ? (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h4 style={{ textAlign: "center", fontWeight: "bold", marginBottom: 16 }}>
        RECIBO
      </h4>
      <Box
        style={{ marginBottom: 16 }}
        className={`d-flex justify-content-center`}
      >
        <h6 style={{ textAlign: "center" }}>
          Recebemos de {data?.cliente?.nomeRazaoSocial}
          {retornarCnpjCpf(data?.cliente)}, a importância de{" "}
          {formatPrice(totalPagamentos(data.pagamentos))}, referente ao(s)
          seguinte(s) título(s):
        </h6>
      </Box>
      <Table size="small" style={{ marginTop: 16 }}>
        <TableHead>
          <TableRow>
            <TableCell variant="head">Meio de Pagamento</TableCell>
            <TableCell variant="head">Condição</TableCell>
            <TableCell variant="head">Valor Pago</TableCell>
            <TableCell variant="head">Data e Hora</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.pagamentos.map((pagamento, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{pagamento?.meioPagamento}</TableCell>
                <TableCell>{pagamento?.condicaoPagamento}</TableCell>
                <TableCell>{formatPrice(pagamento?.valorPago)}</TableCell>
                <TableCell>
                  {format(pagamento?.dataPagamento ?? new Date(), "dd/MM/yyyy HH:mm")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Grid container sx={{ mt: 4 }}>
        <h6>
          {`${empresa.enderecoCidade} - ${empresa.enderecoUF}, ${format(
            data.pagamentos.length == 1
              ? data.pagamentos[0]?.dataPagamento
              : new Date(),
            "dd/MM/yyyy HH:mm",
          )}`}
        </h6>
        <h6>{empresa?.cnpj && `CPF/CNPJ ${formatCnpj(empresa.cnpj)}`}</h6>
      </Grid>
    </Box>
  ) : null;
};

export default ReciboPrintLayout;
